import { TFunction } from "i18n";
import { MeasurementTypes } from "models";
import { MUSICAL_NOTES } from "shared/modules/BasicInfo/components/EditBasicInfo";
import {
  IBasicInfoViewModel,
  IFacetsViewModel,
} from "pages/MainPage/components/BasicInfoSection/viewModels";
import { ConverterBasicInfo } from "./types";

function getVocalNoteName(
  basicInfo: ConverterBasicInfo,
  measurementType: MeasurementTypes
): string {
  const measurement = basicInfo.measurements.find(
    (item) => item.measurementType === measurementType
  );

  if (!measurement) {
    return "";
  }

  const musicalNote = MUSICAL_NOTES.find(
    (item) => item.value === measurement.value
  );

  return musicalNote?.name || "";
}

export function mapVocalRange(
  basicInfo: ConverterBasicInfo,
  facets: IFacetsViewModel,
  t: TFunction
): Partial<IBasicInfoViewModel> {
  const lowerNote = getVocalNoteName(
    basicInfo,
    MeasurementTypes.LowerVocalNote
  );
  const upperNote = getVocalNoteName(
    basicInfo,
    MeasurementTypes.UpperVocalNote
  );

  const beltNoteFacet = facets.beltNotes.facets.find((item) =>
    basicInfo.facets.some((facet) => facet.facetId === item.id)
  );
  const beltNote = beltNoteFacet
    ? ` (${t("common:label.beltTo")} ${beltNoteFacet.name})`
    : "";

  const connectorTo = t("common:label.to.lower");
  const upperNoteWithConnector =
    lowerNote && upperNote ? ` ${connectorTo} ${upperNote}` : upperNote;

  return { vocalRange: `${lowerNote}${upperNoteWithConnector}${beltNote}` };
}

export function mapVocalAge(
  basicInfo: ConverterBasicInfo,
  t: TFunction
): Partial<IBasicInfoViewModel> {
  if (basicInfo.vocalAgeFrom && basicInfo.vocalAgeTo) {
    return {
      vocalAge: `${basicInfo.vocalAgeFrom} ${t("common:label.to.lower")} ${basicInfo.vocalAgeTo} ${t("common:label.years")}`,
    };
  }

  if (basicInfo.vocalAgeFrom || basicInfo.vocalAgeTo) {
    return {
      vocalAge: `${basicInfo.vocalAgeFrom || basicInfo.vocalAgeTo} ${t("common:label.years")}`,
    };
  }

  return {};
}
